import logger from 'utils/logger.util';

const L = logger('fromObjectToKeys');

const fromObjectToKeys = (object) => {
  try {
    return Object.keys(object);
  } catch (e) {
    L.warn('()', e);
    return [];
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromObjectToKeys;
